var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.04 27.84c0-12.806-10.393-23.2-23.2-23.2s-23.2 10.394-23.2 23.2c0 11.229 7.98 20.579 18.56 22.736V34.8h-4.64v-6.96h4.64v-5.8c0-4.477 3.643-8.12 8.12-8.12h5.8v6.96h-4.64a2.327 2.327 0 0 0-2.32 2.32v4.64h6.96v6.96h-6.96v16.124c11.716-1.16 20.88-11.043 20.88-23.084"
  })));
};
export default SvgFacebook;